async function mapeamento_laboratorio(laboratorio) {
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({
      access_token: sessionStorage.getItem("token"),
      laboratorio: laboratorio,
    }),
  };

  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "sensidia/laboratorio/mapeamento_laboratorio.php", requestOptions);
    const data = await response.json();

    if (response.status === 200 && data.cnpjLabConecta) {
      return data.cnpjLabConecta;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Erro na verificação de mapeamento:", error);

    return false;
  }
}

export { mapeamento_laboratorio };
